"use strict";

exports.__esModule = true;
exports.ScrollableChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _createXScale = require("./createXScale");
var _createYScale = require("./createYScale");
var _ScrollableMetricChartBody = require("./ScrollableMetricChartBody");
var _ScrollableMetricChartYAxis = require("./ScrollableMetricChartYAxis");
var _XAxisLabel = require("./XAxisLabel");
var _Tooltip = require("./Tooltips/Tooltip");
var _TimeContext = require("../../../Time/TimeContext");
var _tooltipReducer = require("./Tooltips/tooltipReducer");
var _tooltipHandlers = require("./Tooltips/tooltipHandlers");
var _styles = require("./styles");
var _chartHelpers = require("./chartHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "ScrollableChart__FlexContainer",
  componentId: "sc-11hk3ge-0"
})(["display:flex;justify-content:space-between;overflow:visible;", "}"], function (props) {
  return props.activeDevice && ".bar:not([data-key=\"" + props.activeDevice + "\"]){\n      opacity: 0.3\n    }";
});
var LegendsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScrollableChart__LegendsWrapper",
  componentId: "sc-11hk3ge-1"
})([""]);
var getBodyHeight = function getBodyHeight(height, hideXAxis, xAxisHeight, scrollBarHeight, XAxisLabelHeight) {
  var bodyHeight = height;
  if (!hideXAxis) {
    bodyHeight -= xAxisHeight;
  }
  bodyHeight = bodyHeight - scrollBarHeight - XAxisLabelHeight;
  return bodyHeight;
};
var getChartFixedWidth = function getChartFixedWidth(width, padding, hideYAxis, yAxisWidth) {
  var bodyWidth = width - padding * 2;
  if (!hideYAxis) {
    bodyWidth -= yAxisWidth;
  }
  return bodyWidth;
};
var getScrollableChartBodyWidth = function getScrollableChartBodyWidth(allBinsLength, width, bodyWidth) {
  var scrollableWidth = 50 * allBinsLength;
  if (scrollableWidth < width) {
    scrollableWidth = bodyWidth;
  }
  return scrollableWidth;
};
var ScrollableChart = exports.ScrollableChart = function ScrollableChart(props) {
  var _React$useContext = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext.timezone;
  var series = props.series,
    _props$xAxisHeight = props.xAxisHeight,
    xAxisHeight = _props$xAxisHeight === void 0 ? 30 : _props$xAxisHeight,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 0.4 : _props$padding,
    _props$hideXAxis = props.hideXAxis,
    hideXAxis = _props$hideXAxis === void 0 ? false : _props$hideXAxis,
    _props$hideYAxis = props.hideYAxis,
    hideYAxis = _props$hideYAxis === void 0 ? false : _props$hideYAxis,
    _props$hideYUnits = props.hideYUnits,
    hideYUnits = _props$hideYUnits === void 0 ? false : _props$hideYUnits,
    _props$hideXUnits = props.hideXUnits,
    hideXUnits = _props$hideXUnits === void 0 ? false : _props$hideXUnits,
    legends = props.legends,
    _tickYFormat = props.tickYFormat,
    tickXFormat = props.tickXFormat,
    xAxisLabel = props.xAxisLabel,
    axisFormatter = props.axisFormatter,
    _props$builtInTooltip = props.builtInTooltip,
    builtInTooltip = _props$builtInTooltip === void 0 ? true : _props$builtInTooltip;
  var yAxisWidth = hideYAxis ? 0 : hideYUnits ? 35 : 65;
  var Legends = legends;
  var height = props.height,
    width = props.width,
    _props$showLegends = props.showLegends,
    showLegends = _props$showLegends === void 0 ? true : _props$showLegends;
  var _useState = (0, _react.useState)(""),
    activeDevice = _useState[0],
    setActiveDevice = _useState[1];
  var scrollBarHeight = 20;
  var XAxisLabelHeight = !(hideXUnits || hideXAxis) ? 20 : 0;
  var widthOfLegends = 135;
  height = height - padding;
  if (!legends) {
    showLegends = false;
  }
  if (showLegends) {
    width = width - widthOfLegends;
  }
  var allBinsLength = (0, _chartHelpers.totalXAxisPartitions)(series);
  var bodyHeight = getBodyHeight(height, hideXAxis, xAxisHeight, scrollBarHeight, XAxisLabelHeight);
  var chartFixedWidth = getChartFixedWidth(width, padding, hideYAxis, yAxisWidth);
  var scrollableChartWidth = getScrollableChartBodyWidth(allBinsLength, width, chartFixedWidth);
  height = height - scrollBarHeight - (hideXUnits ? 0 : XAxisLabelHeight);
  var xScale = (0, _react.useMemo)(function () {
    return (0, _createXScale.createXScale)(0, scrollableChartWidth, series, {
      padding: padding
    });
  }, [scrollableChartWidth, series]);
  var yScales = (0, _react.useMemo)(function () {
    return (0, _createYScale.createYScales)(bodyHeight, 0, series);
  }, [bodyHeight, series]);
  var chart = (0, _react.useMemo)(function () {
    return series.map(_chartHelpers.normalizeSeries).map(function (item, key) {
      var unit = item.unit;
      var yScale = yScales[unit] ? yScales[unit].scale : null;
      if (!yScale) {
        return null;
      }
      return item.render({
        key: key,
        series: item,
        x: 0,
        y: padding,
        width: scrollableChartWidth,
        height: bodyHeight,
        xScale: xScale,
        yScale: yScale,
        barWidth: xScale.bandwidth(),
        padding: padding
      });
    });
  }, [scrollableChartWidth, bodyHeight, series]);
  var _useReducer = (0, _react.useReducer)(_tooltipReducer.tooltipReducer, _tooltipReducer.tooltipPropsInitState),
    tooltipProps = _useReducer[0],
    tooltipDispatcher = _useReducer[1];
  return /*#__PURE__*/_react["default"].createElement(FlexContainer, {
    "data-testid": "scrollable-metric-chart",
    className: "ScrollableMetricChart",
    height: height,
    activeDevice: activeDevice,
    style: {
      marginBottom: scrollBarHeight
    },
    onMouseLeave: (0, _tooltipHandlers.mouseLeaveHandler)(tooltipDispatcher, true)
  }, /*#__PURE__*/_react["default"].createElement(_styles.ChartWrapper, {
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_ScrollableMetricChartYAxis.ScrollableMetricChartYAxis, {
    yScales: yScales,
    bodyWidth: chartFixedWidth,
    yAxisWidth: yAxisWidth,
    hideYUnits: hideYUnits,
    tickYFormat: typeof _tickYFormat === "function" ? _tickYFormat : _chartHelpers.tickYFormat,
    hideYAxis: hideYAxis,
    padding: padding,
    height: bodyHeight
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "scrollable-metric-chart-body",
    style: {
      width: chartFixedWidth,
      position: "relative",
      marginLeft: "-1px",
      display: "flex",
      flexDirection: "column",
      marginTop: hideXAxis ? "1px" : "0px",
      overflow: "auto"
    },
    onMouseMove: (0, _tooltipHandlers.mouseMoveHandler)(tooltipDispatcher),
    onScroll: (0, _tooltipHandlers.scrollHandler)(tooltipDispatcher),
    onMouseLeave: (0, _tooltipHandlers.mouseLeaveHandler)(tooltipDispatcher)
  }, /*#__PURE__*/_react["default"].createElement(_ScrollableMetricChartBody.ScrollableMetricChartBody, {
    width: scrollableChartWidth,
    height: height,
    yAxisHeight: bodyHeight,
    bars: chart,
    hideXAxis: hideXAxis,
    xAxisHeight: xAxisHeight,
    padding: padding,
    xScale: xScale,
    tickXFormat: tickXFormat,
    axisFormatter: axisFormatter
  }), !hideXUnits ? /*#__PURE__*/_react["default"].createElement(_XAxisLabel.XAxisLabel, {
    hideXUnits: hideXUnits,
    hideXAxis: hideXAxis,
    XAxisLabelHeight: XAxisLabelHeight,
    scrollableWidth: scrollableChartWidth,
    bodyWidth: chartFixedWidth,
    padding: padding,
    xAxisLabel: xAxisLabel
  }) : null), /*#__PURE__*/_react["default"].createElement(_Tooltip.TooltipWrapper, {
    height: bodyHeight,
    width: scrollableChartWidth,
    nonScrollableWidth: chartFixedWidth,
    xScale: xScale,
    yScales: yScales,
    tooltipFormatters: props.tooltipFormatters,
    series: series,
    padding: padding,
    tickYFormat: typeof _tickYFormat === "function" ? _tickYFormat : _chartHelpers.tickYFormat,
    tickXFormat: tickXFormat({
      scale: xScale,
      bodyWidthToBeUsed: scrollableChartWidth,
      timezone: timezone
    }),
    tooltipProps: tooltipProps,
    enableTooltip: !!(builtInTooltip && props.tooltipFormatters),
    padOffset: yAxisWidth
  })), showLegends && Legends && /*#__PURE__*/_react["default"].createElement(LegendsWrapper, {
    "data-testid": "legends"
  }, /*#__PURE__*/_react["default"].createElement(Legends, {
    width: widthOfLegends,
    height: bodyHeight,
    activeDevice: activeDevice,
    setActiveDevice: setActiveDevice
  })));
};